import React from "react";
import PropTypes from "prop-types";
import history from "~/utils/history";

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class LinkComponent extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    addQueryParameters: PropTypes.bool
  };

  static defaultProps = {
    onClick: null
  };

  handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    event.preventDefault();
    history.push(this.props.to);
  };

  render() {
    const { to, children, addQueryParameters, ...props } = this.props;

    let href = to;
    if (is.truthy(addQueryParameters) && is.not.empty(queryParameters)) {
      const queryCollection = _.omit(queryParameters, ["stockTurn", "suits"]);
      const queryArray = _.map(queryParameters, (value, key) => `${key}=${value}`);

      href = href + `?${_.join(queryArray, "&")}`;
    }

    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
}

export default LinkComponent;



// WEBPACK FOOTER //
// ./src/components/LinkComponent/index.js